import { render } from "./daysgroups.vue?vue&type=template&id=6966275e&scoped=true"
import script from "./daysgroups.vue?vue&type=script&lang=js"
export * from "./daysgroups.vue?vue&type=script&lang=js"

import "./daysgroups.vue?vue&type=style&index=0&id=6966275e&scoped=true&lang=css"

import exportComponent from "E:\\项目\\潞安6s移动端\\H5\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6966275e"]])

export default __exports__